/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useContext, useEffect, useState } from 'react';
import jwt_decode from "jwt-decode";
import { useLocation, useNavigate } from 'react-router-dom';

export const AuthContext = createContext({});
export const AuthProvider = ({children}) => {
  const LOCALSTORAGE_NAME = 'eskala-diadascriancas-2022';
  const INTERNAL_URL_DEFAULT = '/cupom';
  const NAVIAGATE_DELAY = 50;
  const REGISTER_EXPIRES = 1665619199000;

  const [token, setToken] = useState('');
  const [user, setUser] = useState({});

  const navigate = useNavigate();
  let params = useLocation();
  

  useEffect(() => {
    let mounted = true;
    if (mounted && !!token) {
      localStorage.setItem(LOCALSTORAGE_NAME, token);
      verifyExpToken();
      feedUser();
    }
  
    return () => mounted = false;
  }, [token]);

  const login = (data) => {
    setToken(data);
    navigate(INTERNAL_URL_DEFAULT);
  }

  const logout = () => {
    localStorage.removeItem(LOCALSTORAGE_NAME);
    setToken('');

    setTimeout(() => {
      navigate('/');
    }, NAVIAGATE_DELAY);
  }

  const verifyExpToken = () => {
    let now = Math.floor( new Date().getTime() / 1000 );
    let tokenDecoded = jwt_decode( token );
    
    //expired token
    if ( tokenDecoded.exp < now ) { 
      logout();
      return;
    }

    if ( params.pathname === '/' ) {
      navigate(INTERNAL_URL_DEFAULT);
    }
  }

  const authVerification = () => {
    if ( !!token ) {
      verifyExpToken();
      return;
    }
    if ( localStorage.getItem(LOCALSTORAGE_NAME) ) {
      setToken(localStorage.getItem(LOCALSTORAGE_NAME));
      return;
    }
    if ( params.pathname !== '/' ) {
      logout();
    }
  }

  const feedUser = () => {
    const tokenDecoded = jwt_decode( token );
    setUser({
      name: tokenDecoded.name,
      email: tokenDecoded.email,
      cellphone: tokenDecoded.cellphone,
      cpf: tokenDecoded.cpf,
    });
  }
  
  return (
    <AuthContext.Provider
      value={{
        authVerification,
        login,
        logout,
        NAVIAGATE_DELAY,
        REGISTER_EXPIRES,
        setToken,
        token,
        user,
        verifyExpToken
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext);